import type { SVGProps } from 'react';

export function DesignLayout({ className = '', ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* desktop frame */}
      <rect x="40" y="60" width="260" height="180" rx="4" />
      <line x1="40" y1="80" x2="300" y2="80" />
      <circle cx="55" cy="70" r="2" fill="currentColor" stroke="none" />
      <circle cx="65" cy="70" r="2" fill="currentColor" stroke="none" />
      <circle cx="75" cy="70" r="2" fill="currentColor" stroke="none" />

      {/* wireframe content */}
      <rect x="60" y="100" width="80" height="50" />
      <rect x="150" y="100" width="130" height="50" fill="#E7FF4D" stroke="none" />
      <rect x="60" y="160" width="220" height="12" />
      <rect x="60" y="180" width="180" height="12" />
      <rect x="60" y="210" width="60" height="20" />

      {/* mobile frame */}
      <rect x="250" y="200" width="100" height="170" rx="10" />
      <line x1="250" y1="220" x2="350" y2="220" />
      <line x1="290" y1="210" x2="310" y2="210" strokeWidth="1" />
      <rect x="265" y="235" width="70" height="40" fill="#E7FF4D" stroke="none" />
      <rect x="265" y="285" width="70" height="8" />
      <rect x="265" y="300" width="50" height="8" />
      <circle cx="300" cy="355" r="8" />
    </svg>
  );
}
